import React from 'react'
import PropTypes from 'prop-types'
import PersonalSpace from '../../../molecules/PersonalSpace'
import useColumnBuilderStyles from './columnBuilderStyles'
import { CATALOG_GROUPS } from './columnBuilderUtils'

export default function CatalogPanel ({ onAddColumn }) {
  const classes = useColumnBuilderStyles()

  return (
    <div className={classes.catalogPanel}>
      <div className={classes.panelHeader}>Available Columns</div>
      {CATALOG_GROUPS.map(group => (
        <React.Fragment key={group.category}>
          <div className={classes.categoryHeader}>{group.category}</div>
          {group.items.map(entry => (
            <div
              key={entry.columnType}
              className={classes.catalogItem}
              onClick={() => onAddColumn(entry.columnType)}
            >
              {entry.label}
            </div>
          ))}
        </React.Fragment>
      ))}
      <PersonalSpace size={60} />
    </div>
  )
}

CatalogPanel.propTypes = {
  onAddColumn: PropTypes.func.isRequired
}
